<template>
  <div class="products">
    <div v-show="editId == 0 && logisticsId == 0 && invoiceId == 0 && confirmId == 0" class="searchBox">
      <a-form class="ant-advanced-search-form" :form="form">
        <a-row :gutter="24">
          <!-- 奖项 -->
          <a-col :span="6">
            <a-form-item :label="$t('admin-profile-product/awards')">
              <a-select v-model="form.award_id">
                <a-select-option v-for="i in awards" :key="i.id" :value="i.id">{{ i.title }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- 参赛编号 -->
          <a-col :span="6">
            <a-form-item :label="$t('user-tools/code')">
              <a-input v-model="form.pi_code" />
            </a-form-item>
          </a-col>
          <!-- 作品名称 -->
          <a-col :span="6">
            <a-form-item :label="$t('user-productInfo-product/productName')">
              <a-input v-model="form.name_cn" />
            </a-form-item>
          </a-col>
          <!-- 作品类型 -->
          <a-col :span="6">
            <a-form-item :label="$t('user-productInfo-product/type')">
              <a-input v-model="form.type_cn" />
            </a-form-item>
          </a-col>
          <!-- 申请人姓名 -->
          <a-col :span="6">
            <a-form-item :label="$t('admin-profile-product/name')">
              <a-input v-model="form.name" />
            </a-form-item>
          </a-col>
          <!-- 电子邮箱 -->
          <a-col :span="6">
            <a-form-item :label="$t('user-productInfo-brand/email')">
              <a-input v-model="form.email" />
            </a-form-item>
          </a-col>
          <!-- 注册状态 -->
          <a-col :span="6">
            <a-form-item :label="isAwards ? '获奖情况' : $t('admin-profile-product/registrationStatus')">
              <a-select v-model="form.register_status">
                <a-select-option
                  v-for="i in (isAwards ? award_status : register_status)"
                  :key="i.value"
                  :value="i.value"
                >{{ i.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item :label="$t('admin-profile-product/deliveryStatus')">
              <a-select v-model="form.delivery_status">
                <a-select-option
                  v-for="i in submit_status"
                  :key="i.value"
                  :value="i.value"
                >{{ i.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <!-- 类别 -->
          <a-col :span="6">
            <a-form-item :label="$t('admin-profile-product/type')">
              <a-select v-model="form.category_id" allow-clear placeholder="请选择类别">
                <a-select-option v-for="i in cates" :key="i.value" :value="i.value">{{ i.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- 客户经理 -->
          <!-- <a-col :span="6">
            <a-form-item :label="$t('user-productInfo-myProduct/manager')">
              <a-select v-model="form.manager_id">
                <a-select-option :value="''">{{ $t('admin-judge/total') }}</a-select-option>
                <a-select-option v-for="i in managers" :key="i.id" :value="i.id">{{ i.lastname || '' }} {{ i.firstname || '' }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <!-- 国家及地区 -->
          <a-col :span="6">
            <a-form-item :label="$t('user-productInfo-brand/country')">
              <a-select v-model="form.country" show-search allow-clear @change="onCountryChange">
                <a-select-option
                  v-for="i in countryFormat[$i18n.locale || 'zh']"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- 省份 -->
          <a-col v-if="form.country === 'China' || form.country === '中国'" :span="6">
            <a-form-item :label="$t('admin-judge420/name7')">
              <a-select
                v-model="form.province"
                show-search
                allow-clear
                :placeholder="$t('admin-judge420/name7')"
                @change="form.city = ''"
              >
                <a-select-option
                  v-for="i in provinceData"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- 城市 -->
          <a-col :span="6">
            <a-form-item :label="$t('user-productInfo-brand/city')">
              <a-input v-if="form.country !== 'China' && form.country !== '中国'" v-model="form.city" />
              <a-select
                v-if="form.country === 'China' || form.country === '中国'"
                v-model="form.city"
                show-search
                allow-clear
                :placeholder="$t('user-productInfo-brand/city')"
                @change="form.region = ''"
              >
                <a-select-option
                  v-for="i in cityData"
                  :key="i"
                  :value="i"
                >
                  {{ i }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- 单位信息 -->
          <a-col :span="6">
            <a-form-item :label="$t('user-account-address/company')">
              <a-input v-model="form.company_info" />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item :label="$t('admin-profile-product/payStatus')">
              <a-select v-model="form.pay_status">
                <a-select-option v-for="i in pays" :key="i.value" :value="i.value">{{ i.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->
          <a-col :span="24" style="margin-top: 5px;">
            <!-- 导出XLS -->
            <a-button @click="exportXls">{{ $t('admin-profile-product/exportXls') }}</a-button>
            <!-- 导出PDF -->
            <a-button style="margin-left: 21px;" @click="exportPdf">{{ $t('admin-profile-product/exportPdf') }}</a-button>
            <!-- 选项 -->
            <a-button style="margin-left: 21px;" @click="showCheckList = !showCheckList">{{ $t('admin-profile-product/options') }}</a-button>
            <!-- <a-dropdown v-if="[4, 5].indexOf(role) !== -1" style="float: right;">
              <a-menu slot="overlay" @click="handleMenuClick">
                <a-menu-item :key="$t('view-components-components/importAward')">{{ $t('view-components-components/importAward') }}</a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px"> {{ $t('view-components-components/more') }} <a-icon type="down" /> </a-button>
            </a-dropdown> -->
            <!-- 导出获奖信息 -->
            <a-button style="margin-left: 21px;" @click="exportPicture('info')">{{ isAwards ? $t('admin-profile-product/exportInfo') : $t('admin-profile-product/exportPic') }}</a-button>
            <!-- 新增的三个导出Excel功能 -->
            <a-dropdown style="margin-left: 21px;">
              <a-menu slot="overlay" @click="handleExportMenuClick">
                <a-menu-item key="export_excel_product_group_by_cate">按分类分组导出Excel</a-menu-item>
                <a-menu-item key="export_excel_product_group_by_company">按企业分组导出Excel</a-menu-item>
                <a-menu-item key="export_excel_product_group_by_region">按地区分组导出Excel</a-menu-item>
              </a-menu>
              <a-button>
                分组导出Excel <a-icon type="down" />
              </a-button>
            </a-dropdown>
            <!-- 清空 -->
            <a-button type="primary" style="float: right;" @click="getList">{{ $t('user-productInfo-myProduct/search') }}</a-button>
            <!-- 搜索 -->
            <a-button style="float: right;margin-right: 8px;" @click="clearSearch">{{ $t('admin-products-products/empty') }}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 点击选项时候出现的多选框区域 -->
    <div v-show="showCheckList && editId == 0 && logisticsId == 0 && invoiceId == 0 && confirmId == 0" class="checkboxList">
      <div class="inner">
        <a-checkbox-group v-model="checkListArr" style="width: 100%" @change="onChange">
          <a-row>
            <!-- 参赛编号 -->
            <a-col :span="6">
              <a-checkbox value="pi_code_xls">{{ $t('user-tools/code') }}</a-checkbox>
            </a-col>
            <!-- 作品名称 -->
            <a-col :span="6">
              <a-checkbox value="name_cn_xls">{{ $t('user-productInfo-product/productName') }}</a-checkbox>
            </a-col>
            <!-- 作品类型 -->
            <a-col :span="6">
              <a-checkbox value="type_cn_xls">{{ $t('user-productInfo-product/type') }}</a-checkbox>
            </a-col>
            <!-- 类别 -->
            <a-col :span="6">
              <a-checkbox value="category_xls">{{ $t('admin-profile-product/type') }}</a-checkbox>
            </a-col>
            <!-- 作品长度 -->
            <a-col :span="6">
              <a-checkbox value="height_xls">{{ $t('user-productInfo-logistics/hight') }}</a-checkbox>
            </a-col>
            <!-- 宽度 -->
            <a-col :span="6">
              <a-checkbox value="width_xls">{{ $t('user-productInfo-logistics/width') }}</a-checkbox>
            </a-col>
            <!-- 厚度 -->
            <a-col :span="6">
              <a-checkbox value="depth_xls">{{ $t('user-productInfo-logistics/depth') }}</a-checkbox>
            </a-col>
            <!-- 作品标签 -->
            <a-col :span="6">
              <a-checkbox value="product_label_xls">{{ $t('user-comphonents-step1/product-label') }}</a-checkbox>
            </a-col>
            <a-col :span="24" class="title">APPLICANT</a-col>
            <!-- 性别 -->
            <a-col :span="6">
              <a-checkbox value="form_xls">{{ $t('user-productInfo-brand/form') }}</a-checkbox>
            </a-col>
            <!-- 申请人姓名 -->
            <a-col :span="6">
              <a-checkbox value="applicant_name_xls">{{ $t('admin-profile-product/name') }}</a-checkbox>
            </a-col>
            <!-- 申请人电子邮箱 -->
            <a-col :span="6">
              <a-checkbox value="applicant_email_xls">{{ $t('admin-products-products/applicante') }}</a-checkbox>
            </a-col>
            <!-- 手机号 -->
            <a-col :span="6">
              <a-checkbox value="phone_xls">{{ $t('user-productInfo-brand/phone') }}</a-checkbox>
            </a-col>
            <!-- 单位名称 -->
            <a-col :span="6">
              <a-checkbox value="applicant_company_xls">{{ $t('user-productInfo-brand/company') }}</a-checkbox>
            </a-col>
            <!-- <a-col :span="6">
              <a-checkbox value="applicant_company_info_xls">{{ $t('user-productInfo-brand/companyEn') }}</a-checkbox>
            </a-col> -->
            <!-- 地址 -->
            <a-col :span="6">
              <a-checkbox value="applicant_street_xls">{{ $t('user-productInfo-brand/address') }}</a-checkbox>
            </a-col>
            <!-- <a-col :span="6">
              <a-checkbox value="applicant_zip_xls">{{ $t('user-productInfo-brand/code') }}</a-checkbox>
            </a-col> -->
            <!-- 国家及地区 -->
            <a-col :span="6">
              <a-checkbox value="applicant_country_xls">{{ $t('register/country') }}</a-checkbox>
            </a-col>
            <!-- <a-col :span="6">
              <a-checkbox
                value="applicant_invoice_xls"
                style="display:flex"
              >{{ $t('admin-products-products/Invoiceadd') }}</a-checkbox>
            </a-col> -->
            <a-col :span="24" class="title">CONTACT</a-col>
            <!-- 客户经理 -->
            <!-- <a-col :span="6">
              <a-checkbox value="customer_manager_xls">{{ $t('setting-user/manager') }}</a-checkbox>
            </a-col> -->
            <!-- 用户标签 -->
            <a-col :span="6">
              <a-checkbox value="user_label_xls">{{ $t('view-components-components/user-label') }}</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
      </div>
    </div>
    <!-- 表格区域 -->
    <a-table
      v-show="editId == 0 && logisticsId == 0 && invoiceId == 0 && confirmId == 0"
      :columns="columns"
      :data-source="data"
      class="table"
      :pagination="pagination"
      row-key="id"
      :scroll="{ y: 'calc(100vh - 230px)' }"
      @change="pageChange"
    >
      <!-- 表格索引 -->
      <span slot="index" slot-scope="text,row,index">
        <div>
          {{ index + 1 + (pagination.current - 1) * 10 }}
        </div>
      </span>
      <!-- 操作 -->
      <span
        slot="action"
        slot-scope="text, row"
        class="action-container"
      >
        <!-- 上方操作按钮组 -->
        <div class="action-buttons-top">
          <!-- <span v-if="[2,3,4,5,6].indexOf(role) !== -1" :title="$t('view-components-components/view')">
            <svg-icon
              icon-class="check"
              style="cursor: pointer;"
              @click="view(row)"
            />
          </span> -->
          <!-- 编辑 -->
          <span v-if="[2, 4,5].indexOf(role) !== -1" :title="$t('user-address/edit')" class="action-item">
            <a-button size="small" @click="edit(row)">{{ $t('user-address/edit') }}</a-button>
            <!-- <svg-icon
              icon-class="write"
              style="cursor: pointer;"
              @click="edit(row)"
            /> -->
          </span>
          <!-- 下载 -->
          <span v-if="row.image.length && [4,5].indexOf(role) !== -1" :title="$t('view-components-components/downloadPic')" class="action-item">
            <!-- <svg-icon
              icon-class="download_a"
              style="cursor: pointer;"
              @click="download(row)"
            /> -->
            <a-button size="small" @click="download(row)">{{ $t('view-components-components/downloadPic') }}</a-button>
          </span>
          <!-- <span v-if="row.register_status >= 3 && [1,3].indexOf(row.pay_status) !== -1 && [4,5,6].indexOf(role) !== -1" :title="$t('user-productInfo-logistics/logistics')" style="margin-left: 5px;">
            <svg-icon
              icon-class="logistics"
              style="cursor: pointer;transform: scale(1.2);"
              @click="editLogistics(row)"
            />
          </span>
          <span v-if="row.register_status >= 3 && [1,3].indexOf(row.pay_status) !== -1 && [4,5].indexOf(role) !== -1" :title="$t('view-components-components/invoice')" style="margin-left: 5px;">
            <svg-icon
              icon-class="invoice"
              style="cursor: pointer;transform: scale(1.2);"
              @click="editInvoice(row)"
            />
          </span> -->
          <!-- 确认图标 -->
          <span v-if="row.register_status > 3" :title="$t('view-components-components/confirmed')" :style="row.confirmation_status ? 'color: #ed1c24;' : ''" class="action-item">
            <svg-icon icon-class="confirm" style="transform: scale(1.2);cursor: pointer;" @click="showConfirm(row)" />
          </span>
        </div>
        <!-- 下方删除按钮 -->
        <div class="action-buttons-bottom">
          <span v-if="[4,5].indexOf(role) !== -1" class="action-item">
            <a-button size="small" type="danger" @click="confirmDelete(row)">删除</a-button>
            <a-button size="small" type="primary" style="margin-left: 5px;" @click="downloadForm(row)">下载报名表</a-button>
          </span>
        </div>
      </span>
      <!-- 图片 -->
      <span slot="image" slot-scope="text, row">
        <div style="padding-bottom: 10px;">
          <img :src="text[0] && text[0].thumb_image_url" alt height="40" width="60" style="cursor: pointer; object-fit: cover;" @click="preview(text)">
          <div class="tag" style="max-width: 70px;" :title="row.product_tag.map(i => i.label).join(',')">{{ row.product_tag.map(i => i.label).join(',') }}</div>
        </div>
      </span>
      <!-- 申请人姓名 -->
      <span slot="name" slot-scope="text, row">
        <div>
          <div>{{ text.name }}</div>
          <div class="tag" style="max-width: 80px;" :title="row.user.user_tag.map(i => i.label).join(',')">{{ row.user.user_tag.map(i => i.label).join(',') }}</div>
        </div>
      </span>
      <!-- 申请人手机号 -->
      <span slot="phone" slot-scope="text, row">
        <div>{{ row.user.phone }}</div>
      </span>
      <!-- 参赛编号 -->
      <span slot="code" slot-scope="text, row">
        <div style="cursor: pointer;" @click="view(row)">{{ text }}</div>
      </span>
      <!-- 作品名称-中文 -->
      <span slot="name_cn" slot-scope="text, row">
        <div style="cursor: pointer;" @click="view(row)">{{ text }}</div>
      </span>
      <!-- <span slot="name_en" slot-scope="text, row">
        <div style="cursor: pointer;" @click="view(row)">{{ text }}</div>
      </span> -->
      <!-- 注册状态 -->
      <span slot="register" slot-scope="text, row">
        <div v-if="!(role === 4 || role === 5)">
          <span v-if="register_status_format[text] === $t('admin-products-products/goldaward')" style="color: #ED7D31;font-weight: bold;">{{ register_status_format[text] }}</span>
          <span v-if="register_status_format[text] === $t('admin-products-products/silveraward')" style="color: #FF0000;font-weight: bold;">{{ register_status_format[text] }}</span>
          <span v-if="register_status_format[text] === $t('admin-products-products/winning')" style="color: #5B9BD5;font-weight: bold;">{{ register_status_format[text] }}</span>
        </div>
        <div>
          <!-- v-if="(role === 4 || role === 5) && (text === 1 || text === 2 || text === 3 || text === 4 || text === 5 )" -->
          <a-select
            v-if="role === 4 || role === 5"
            :default-value="text"
            style="width: 100%;"
            @change="registerStatusChange($event, row.id)"
          >
            <a-select-option
              key="0"
              :value="0"
            >
              {{ $t('user-tools/notCompleted') }}
            </a-select-option>
            <a-select-option
              key="1"
              :value="1"
            >
              {{ $t('user-tools/completed') }}
            </a-select-option>
            <a-select-option
              key="2"
              :value="2"
            >
              {{ $t('admin-products-products/shortlisted') }}
            </a-select-option>
            <a-select-option
              key="-2"
              :value="-2"
            >
              审核未通过
            </a-select-option>
            <a-select-option
              key="3"
              :value="3"
            >
              {{ $t('user-tools/success') }}
            </a-select-option>
            <a-select-option
              key="4"
              :value="4"
            >
              <span style="color: #5B9BD5;font-weight: bold;">{{ $t('admin-products-products/winning') }}</span>
            </a-select-option>
            <a-select-option
              key="5"
              :value="5"
            >
              <span style="color: #FF0000;font-weight: bold;">{{ $t('admin-products-products/silveraward') }}</span>
            </a-select-option>
            <a-select-option
              key="6"
              :value="6"
            >
              <span style="color: #ED7D31;font-weight: bold;">{{ $t('admin-products-products/goldaward') }}</span>
            </a-select-option>
            <a-select-option
              key="7"
              :value="7"
            >
              优胜奖
            </a-select-option>
            <a-select-option
              key="8"
              :value="8"
            >
              入围
            </a-select-option>
          </a-select>
        </div>
      </span>
      <!-- <span slot="delivery" slot-scope="text">
        <span>{{ submit_status[text].name }}</span>
      </span>
      <span slot="pay" slot-scope="text">
        <span>{{ pays[text].name }}</span>
      </span> -->
    </a-table>
    <registrate
      v-if="editId != 0"
      :edit-id="editId"
      @setEditId="setEditId"
    />
    <!-- <logistics
      v-if="logisticsId !== 0"
      :logistics-id="logisticsId"
      @hideComponents="hideComponents"
    />
    <invoice
      v-if="invoiceId !== 0"
      :invoice-id="invoiceId"
      @hideComponents="hideComponents"
    /> -->
    <Modal
      :show-modal="showModal"
      :cancel-text="$t('register-verify/close')"
      :confirm-text="$t('admin-profile-edit/save')"
      @confirm="upload"
      @cancel="showModal = false"
    >
      <div class="modal_title">
        {{ modalTitle }}
      </div>
      <div class="modal_inner">
        <span>{{ $t('user-productInfo-description/upload') }} excel</span>
        <!-- :file-list="form.images" -->
        <a-upload
          action=""
          list-type="picture-card"
          style="height: 150px;"
          :file-list="files"
          @change="handleChange"
        >
          <div style="pointer-events: none;">
            <a-button style="margin: 3px 15px 0 0;float:left;pointer-events: auto;"><a-icon type="upload" /> {{ $t('admin-message-message/upload') }}</a-button>
          </div>
        </a-upload>
      </div>
    </Modal>
    <PreviewImage v-if="previewVisible" :images="images" :index="imagesIndex" @closePreview="closePreview" />
    <ConfirmBox v-if="confirmId != 0" :confirm-id="confirmId" @goBack="goBack" />
  </div>
</template>
<script>
// 导入api函数
import { searchs, searchsIndexBefore, searchsDownload, searchsChangeStatus, deleteProduct, productsWordExport } from '@/api/product'
// 导入结果，
import { importResult, importNomination, exportOrder } from '@/api/document'
// 修改和获取，及移除cookie的pageKey值，获取key的值
import { getLKey, getPageKey, setPageKey, removePageKey } from '@/utils/auth'
// 导入地区数据
import countryFormat from '@/utils/country.js'
import area_cn from '@/utils/area_cn.js' // 中文
import area_en from '@/utils/area_en.js' // 英文
// 步骤注册组件
import registrate from '../../user/registration'
// import logistics from './logistics'
// import invoice from './invoice'
// 模态框组件
import Modal from '@/views/components/Modal.vue'
// 预览图组件
import PreviewImage from '@/views/components/PreviewImage'
// 猜测：可能用于检查的组件
import ConfirmBox from '@/views/components/ConfirmBox'
// 表格行头
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    scopedSlots: { customRender: 'index' },
    width: '50px'
  },
  {
    title: '作品照片',
    dataIndex: 'image',
    scopedSlots: { customRender: 'image' },
    width: '80px'
  },
  {
    title: '参赛编号',
    dataIndex: 'pi_code',
    scopedSlots: { customRender: 'code' },
    width: '120px'
  },
  {
    title: '作品名称(中文)',
    dataIndex: 'name_cn',
    scopedSlots: { customRender: 'name_cn' },
    width: '120px'
  },
  // {
  //   title: '作品名称(英文)',
  //   dataIndex: 'name_en',
  //   scopedSlots: { customRender: 'name_en' },
  //   width: '140px'
  // },
  {
    title: '注册状态',
    dataIndex: 'register_status',
    scopedSlots: { customRender: 'register' },
    width: '120px'
  },
  // {
  //   title: '递交状态',
  //   dataIndex: 'delivery_status',
  //   scopedSlots: { customRender: 'delivery' },
  //   width: '100px'
  // },
  // {
  //   title: '支付状态',
  //   dataIndex: 'pay_status',
  //   scopedSlots: { customRender: 'pay' },
  //   width: '120px'
  // },
  {
    title: '申请人姓名',
    dataIndex: 'user',
    scopedSlots: { customRender: 'name' },
    width: '90px'
  },
  {
    title: '申请人手机号',
    dataIndex: 'user',
    scopedSlots: { customRender: 'phone' },
    width: '100px'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'action' },
    width: '120px'
  }
]

export default {
  components: {
    registrate,
    // logistics,
    // invoice,
    Modal,
    PreviewImage,
    ConfirmBox
  },
  props: {
    // 是不是获奖作品展示页面
    isAwards: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      data: [], // 表格数据
      columns, // 表格列头
      form: { // 参赛作品的，
        award_id: '',
        pi_code: '',
        name_cn: '',
        type_cn: '',
        name: '',
        email: '',
        register_status: -1,
        delivery_status: '',
        category_id: '',
        manager_id: '',
        country: '中国',
        province: '',
        city: '',
        company_info: '',
        pay_status: ''
      },
      pagination: { // 总页码和当前页码数据
        current: 1,
        total: 0,
        showTotal: total => { // 展示共筛选出多少条信息
          return getLKey() === 'en' ? `total ${total} ` : `共筛选出 ${total} 条信息`
        }
      },
      awards: [], // 奖项数组
      register_status: [], // 表格选中的注册状态/每一条数据的完成状态
      register_status_format: {}, // 表格注册状态下面的红色区域标识
      award_status: [], // 注册状态的数组数据
      submit_status: [], // 未知且信息未用
      cates: [], // 类别的数组数据
      managers: [], // 客户经理信息
      pays: [], // 未知且信息未用
      checkList: {}, // 未知且信息未用
      checkListArr: ['pi_code_xls', 'name_cn_xls', 'name_en_xls', 'type_cn_xls', 'type_en_xls', 'category_xls', 'height_xls', 'width_xls', 'depth_xls', 'was_paid_xls', 'registration_status_xls', 'product_label_xls', 'form_xls', 'applicant_name_xls', 'applicant_email_xls', 'phone_xls', 'applicant_company_xls', 'applicant_company_info_xls', 'applicant_street_xls', 'applicant_country_xls', 'contact_form_xls', 'contact_name_xls', 'contact_email_xls', 'contact_phone_xls', 'user_label_xls'], // 用户选中的选项的信息
      showCheckList: false, // 是否展示选中的选项
      role: 1, // 判断当前登录的用户是否有编辑表格信息的能力
      editId: 0, // 代表的是不是进入了编辑此作品信息的状态
      logisticsId: 0, // 未知
      invoiceId: 0, // 未知
      files: [], // 猜测：可能跟上传文件有关
      modalTitle: '', // 模态框标题
      showModal: false, // 是否展示模态框
      // 图片预览相关start
      images: [], // 图片数组
      imagesIndex: 0, // 展示的图片索引
      previewVisible: false, // 是否展示图片
      // 图片预览相关end
      confirmId: 0, // 未知
      countryFormat: countryFormat
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale // 本地化
    },
    provinceData() { // 所有的省份
      return this.locale === 'en' ? area_en.provinceData : area_cn.provinceData
    },
    cityData() { // 所有的城市
      const area = this.locale === 'en' ? area_en : area_cn
      return area.cityData[this.form.province]
    }
  },
  watch: {
    locale(e) {
      console.log(e) // 根据e对变量重新赋值
      this.columns[0].title = this.$t('admin-judge/index')
      this.columns[1].title = this.$t('admin-products-products/pphoto')
      this.columns[2].title = this.$t('user-tools/code')
      this.columns[3].title = this.$t('user-productInfo-product/productName')
      // this.columns[4].title = this.$t('user-productInfo-product/productEname')
      /*  this.columns[3].title = e === 'en' ? this.$t('user-productInfo-product/typeEn') : this.$t('user-productInfo-product/type') */
      this.columns[4].title = this.isAwards ? '获奖情况' : this.$t('user-productInfo-myProduct/status')
      this.columns[5].title = this.$t('admin-profile-product/name')
      // this.columns[7].title = this.$t('admin-profile-product/labels')
      this.columns[6].title = this.$t('user-productInfo-brand/phone')
      this.columns[7].title = this.$t('admin-products-products/operating')
      // this.columns[2].dataIndex = e === 'en' ? 'name_en' : 'name_cn'
      // this.columns[3].dataIndex = e === 'en' ? 'type_en' : 'type_cn'
    }
  },
  created() {
    this.role = this.$store.getters.user.role // 得到当前用户的权限

    this.columns[0].title = this.$t('admin-judge/index') // 列头数据本地化
    this.columns[1].title = this.$t('admin-products-products/pphoto')
    this.columns[2].title = this.$t('user-tools/code')
    this.columns[3].title = this.$t('user-productInfo-product/productName')
    // this.columns[4].title = this.$t('user-productInfo-product/productEname')
    /* this.columns[3].title = this.locale === 'en' ? this.$t('user-productInfo-product/typeEn') : this.$t('user-productInfo-product/type') */
    this.columns[4].title = this.isAwards ? '获奖情况' : this.$t('user-productInfo-myProduct/status')
    this.columns[5].title = this.$t('admin-profile-product/name')
    // this.columns[7].title = this.$t('admin-profile-product/labels')
    this.columns[6].title = this.$t('user-productInfo-brand/phone')
    this.columns[7].title = this.$t('admin-products-products/operating')
    // this.columns[2].dataIndex = this.locale === 'en' ? 'name_en' : 'name_cn'
    // this.columns[3].dataIndex = this.locale === 'en' ? 'type_en' : 'type_cn'
    searchsIndexBefore() // 对请求回来的数据对所有用到的变量初始化，
      .then(res => {
        this.awards = res.awards // 奖项数组
        this.register_status = res.register_status // 表格中每一条数据的注册状态
        this.award_status = res.award_status // 注册状态的数组数据
        this.submit_status = res.submit_status // 未知且未用
        this.cates = res.cates // 类别数组数据
        this.managers = res.managers // 客户经理数组数据
        this.pays = res.pays // 未知信息且未用
        for (const i in res.register_status) { // 表格注册状态下面的红色区域标识被注册状态的名覆盖
          this.register_status_format[res.register_status[i].value] = res.register_status[i].name
        }

        if (res.awards.length) this.form.award_id = res.awards[0].id // 如果奖项存在，把第一项的值赋值给form表单的值
      })
      .catch(res => { // 有错报错
        console.error(res)
      })
    this.getList()
    const id = getPageKey('editProductId') // 获取到是否是编辑表格每一项数据
    if (id) this.editId = id // 如果id存在就赋值给编辑id状态值
    const id2 = getPageKey('editLogisticsId') // 同上，但未用到
    if (id2) this.logisticsId = id2
    const id3 = getPageKey('editInvoiceId') // 同上，但未用到
    if (id3) this.invoiceId = id3
  },
  methods: {
    onCountryChange() { // 当国家改变时，清空省份和城市
      this.form.province = ''
      this.form.city = ''
    },
    getList(page) { // 初始数据的请求
      const params = JSON.parse(JSON.stringify(this.form))
      params.search_type = 'search'
      params.page = typeof page === 'number' ? page : 1
      params.is_award = this.isAwards ? 1 : 0
      searchs(params) // 进行请求，然后对数据进行赋值,如表格数据，页码和总页数数据，
        .then(res => {
          this.data = res.data
          this.pagination.total = res.total
          this.pagination.current = res.current_page
        })
        .catch(res => {
          console.error(res)
        })
    },
    pageChange(e) { // 当页码发生改变后执行的数据更新
      this.getList(e.current)
    },
    view(row) { // 把选中的id传给编辑id，然后打开被编辑id的编辑页面，且只能查看，不能编辑
      this.editId = row.id
      setPageKey('editProductId', row.id)
      setPageKey('readonly', 'true')
    },
    edit(row) { // 把选中的id传给编辑id，然后打开被编辑id的编辑页面,且跳转路由
      this.editId = row.id
      setPageKey('editProductId', row.id)
      const path = this.$router.history.current.path
      this.$router.push({ path, query: { userId: row.user_id }})
    },
    editLogistics(row) { // 编辑...未知
      setPageKey('editLogisticsId', row.id)
      this.logisticsId = row.id
      const path = this.$router.history.current.path
      this.$router.push({ path, query: { userId: row.user_id }})
    },
    editInvoice(row) { // 编辑...未知
      setPageKey('editInvoiceId', row.id)
      this.invoiceId = row.id
      const path = this.$router.history.current.path
      this.$router.push({ path, query: { userId: row.user_id }})
    },
    hideComponents() { // 隐藏组件，logisticsId和invoiceId组件消失，且移除掉两个组件的pageKey值，重新请求数据，刷新页面
      this.logisticsId = 0
      this.invoiceId = 0
      removePageKey('editLogisticsId')
      removePageKey('editInvoiceId')
      this.getList()
    },
    setEditId(value) { // 把数据传给编辑ID，且更新表格数据
      this.editId = value
      this.getList(this.pagination.current)
    },
    download(row) { // 下载通过api函数进行下载
      searchsDownload(row.id)
        .then(res => {
          window.open(res.zip_url)
        })
        .catch(res => {
          console.error(res)
        })
    },
    clearSearch() { // 点击清空按钮后，清除form表单的所有数据
      for (const i in this.form) {
        if (i === 'country') {
          this.form[i] = '中国' // 保持默认国家为中国
        } else {
          this.form[i] = ''
        }
      }
      this.getList()
    },
    onChange(checkedValues) { // 当发生某个多选框发生改变后，执行的代码
      console.log(checkedValues)
      const list = {}
      for (const i of checkedValues) {
        list[i] = 1
      }
      this.checkList = list
    },
    exportXls(isAll) { // 导出xls文件，通过请求下载
      this.onChange(this.checkListArr)
      const params = {
        ...JSON.parse(JSON.stringify(this.checkList)),
        ...this.form
      }
      params.search_type = 'export_excel'
      params.is_award = this.isAwards ? 1 : 0

      searchs(params)
        .then(res => {
          console.log(res)
          // window.open(res.pdf_url)
          window.open(res.excel_url)
        })
        .catch(res => {
          console.error(res)
        })
    },
    exportPdf() { // 到底出pdf文件，通过请求
      this.onChange(this.checkListArr)
      const params = {
        ...JSON.parse(JSON.stringify(this.checkList)),
        ...this.form
      }
      params.search_type = 'export_pdf'
      params.is_award = this.isAwards ? 1 : 0

      searchs(params)
        .then(res => {
          window.open(res.pdf_url)
        })
        .catch(res => {
          console.error(res)
        })
    },
    registerStatusChange(value, id) { // 表格数据的注册信息发生改变，重新请求数据共更新
      const data = {
        id: id,
        status: value
      }
      searchsChangeStatus(data).then(res => {
        this.$message.success({ content: this.$t('admin-password-password/savey'), key: 'message', duration: 4 })
        console.log(res)
      })
    },
    handleMenuClick(e) { // 没有用到
      if (e.key === this.$t('view-components-components/exportAward')) {
        const data = {
          award_id: this.form.award_id,
          pi_code: this.form.pi_code,
          name_cn: this.form.name_cn,
          name_en: this.form.name_en,
          type_cn: this.form.type_cn,
          type_en: this.form.type_en,
          name: this.form.name,
          email: this.form.email,
          register_status: this.form.register_status,
          is_award: this.isAwards ? 1 : 0,
          delivery_status: this.form.delivery_status,
          category_id: this.form.category_id,
          country: this.form.country,
          province: this.form.province,
          city: this.form.city,
          pay_status: this.form.pay_status
        }

        exportOrder(data).then(res => {
          if (res.excel_url) window.open(res.excel_url)
        })
      } else {
        this.modalTitle = e.key
        this.showModal = true
      }
    },
    /**
     * @description 处理分组导出Excel菜单点击事件
     * @param {Object} e 事件对象
     */
    handleExportMenuClick(e) {
      const searchType = e.key
      const params = {
        search_type: searchType
      }

      // 调用导出接口
      searchs(params)
        .then(res => {
          if (res.excel_url) {
            window.open(res.excel_url)
            this.$message.success('导出成功！')
          } else {
            this.$message.error('导出失败，未获取到文件链接')
          }
        })
        .catch(error => {
          console.error('导出失败:', error)
          this.$message.error('导出失败，请稍后重试')
        })
    },
    handleChange({ fileList }) { // 模态框
      this.files = fileList
      this.files[0].status = 'success'

      if (this.files.length > 1) {
        this.$message.error({ content: this.$t('view-components-components/tip20'), key: 'message', duration: 4 })
        this.files.splice(1, 1)
      }
    },
    upload() { // 上传，模态框可能上传了文件
      if (this.files.length) {
        const data = new FormData()
        data.append('excel', this.files[0].originFileObj)
        data.append('name', this.files[0].originFileObj.name)
        if (this.modalTitle === this.$t('view-components-components/importRe')) {
          importNomination(data).then(res => {
            this.$message.success({ content: this.$t('view-components-components/importSucceeded'), key: 'message', duration: 4 })
            this.showModal = false
          })
        }
        if (this.modalTitle === this.$t('view-components-components/importAward')) {
          importResult(data).then(res => {
            this.$message.success({ content: this.$t('view-components-components/importSucceeded'), key: 'message', duration: 4 })
            this.showModal = false
          })
        }
      } else {
        this.$message.warning({ content: this.$t('view-components-components/selectFile'), key: 'message', duration: 4 })
      }
    },
    preview(images) { // 展示预览图
      this.images = images.map(i => i.whole_image_url)
      this.imagesIndex = 0
      this.previewVisible = true
    },
    closePreview() { // 关闭预览图
      this.previewVisible = false
    },
    showConfirm(row) { // 把点击的一行的数据 -未知
      this.confirmId = row.id
      this.confirmation_status = row.confirmation_status
    },
    goBack() { // 当confirmId为0就不会展示-未知
      this.confirmId = 0
      this.getList(this.pagination.current)
    },
    exportPicture(type) { // 导出图片
      this.onChange(this.checkListArr)
      const params = {
        ...JSON.parse(JSON.stringify(this.checkList)),
        ...this.form
      }
      params.search_type = this.isAwards ? 'export_excel_award' : 'product_images'
      params.is_award = this.isAwards ? 1 : 0

      searchs(params)
        .then(res => {
          const url = res.pdf_url || res.excel_url || res.excel_award_url
          const zip = res.award_zip_url || res.pdf_zip_url || res.images_zip_url
          console.log(url, zip)
          if (url)window.open(url)
          if (zip) {
            window.location.href = zip
          }
        })
        .catch(res => {
          console.error(res)
        })
    },
    /**
     * @description 下载报名表
     * @param {Object} row 作品行数据
     */
    downloadForm(row) {
      this.$message.info('开始下载报名表...')
      productsWordExport(row.id)
        .then(res => {
          const url = res.file_url
          if (url) {
            window.open(url, '_blank')
          } else {
            this.$message.error('未获取到下载链接')
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    /**
     * @description 确认删除作品
     * @param {Object} row 作品行数据
     */
    confirmDelete(row) {
      const that = this
      this.$confirm({
        title: '确认删除',
        content: `确定要删除作品"${row.name_cn}"吗？此操作不可撤销。`,
        okText: '确认删除',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return that.deleteProduct(row.id)
        }
      })
    },
    /**
     * @description 删除作品
     * @param {Number} productId 作品ID
     */
    deleteProduct(productId) {
      return deleteProduct(productId)
        .then(() => {
          this.$message.success('作品删除成功')
          // 重新获取数据
          this.getList(this.pagination.current)
        })
        .catch(error => {
          console.error('删除作品失败:', error)
          this.$message.error('删除作品失败，请稍后重试')
        })
    }
  }
}
</script>
<style scoped>
.searchBox {
  padding: 17px 20px 15px 20px;
  background: #ffffff;
}

.table {
  margin-top: 30px;
}

.edit {
  cursor: pointer;
}

.checkboxList {
  width: 100%;
  position: absolute;
  left: 0;
  top: 380px;
  padding: 0px 25px;
  z-index: 99;
}

.checkboxList .inner {
  background: #ffffff;
  border: 1px solid rgba(224, 224, 224, 1);
  padding: 44px 73px;
}

.checkboxList .title {
  font-weight: bold;
  margin-bottom: 8px;
}

.checkboxList label {
  margin-bottom: 34px;
}

.tag {
  border-radius: 5px;
  background: #ed1c24;
  color: #ffffff;
  margin-top: 5px;
  padding: 0px 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  bottom: 5px;
  z-index: 1;
}

.modal_title {
  font-size: 24px;
}

.modal_inner {
  margin-top: 29px;
  line-height: 32px;
}

/* 操作按钮容器样式 */
.action-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 120px;
}

/* 上方操作按钮组 - 横向排列 */
.action-buttons-top {
  display: flex;
  flex-wrap: nowrap;
  gap: 4px;
  align-items: center;
  justify-content: center;
}

/* 下方删除按钮组 - 单独一行 */
.action-buttons-bottom {
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-item {
  display: inline-block;
  margin: 2px;
  flex-shrink: 0;
}
</style>
<style>
.ant-pagination-total-text {
  float: right;
  margin-left: 5px;
}

.ant-table-row-cell-break-word {
  word-break: normal;
}
</style>
